import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
// import EntSetupSidebar from '../ent_setup_mainsidebar/EntSetupSidebar';
import MasterDashboardLayout from '../../../dashboard/MasterDashboardLayout';

function AddOurRecentWebProjects() {

    const [ourRecentWeb, setOurRecentWeb] = useState({
        heading_name: "",
        web_link: "",
    });

    const [image, setImage] = useState('');
    const [picture, setPicture] = useState('');

    useEffect(() => {
        axios.get(`/our-web-dev-project`).then(res => {
            console.log("our-web-dev-project", res.data);
            // if (res.data.status == 200) {
            //     setTotalHeadingCount(res.data.heading_count);
            // }
        })
    }, [])

    const onChangePicture = e => {
        console.log('picture: ', picture);
        setPicture(URL.createObjectURL(e.target.files[0]));
        setImage(e.target.files[0]);
    };

    const handleInput = (e) => {
        setOurRecentWeb({
            ...ourRecentWeb, [e.target.name]: e.target.value
        });
    }

    const submitOurRecentWeb = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('heading_name', ourRecentWeb.heading_name);
        formData.append('web_link', ourRecentWeb.web_link);
        formData.append('image', image);


        if (image == '') {
            Swal.fire("Please fill up all inputs", '', 'error')

        }
        else if (image.size > 524288) {
            Swal.fire("Image size must be less than 0.5 mb", '', 'error')

        }

        else {
            axios.post(`/add-our-web-dev-project`, formData).then(res => {
                if (res.data.status == 200) {
                    Swal.fire(res.data.message, '', 'success')
                    setOurRecentWeb({
                        heading_name: "",
                        web_link: "",
                        error_list: [],
                    });

                    setImage('');
                    setPicture('');
                    document.getElementById('image').value = "";
                }
                else if (res.data.status == 400) {
                    setOurRecentWeb({ ...ourRecentWeb, error_list: res.data.errors });
                }
            })
        }

    }


    return (
        <>
            <MasterDashboardLayout>
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-md-3">
                            <EntSetupSidebar/>
                        </div> */}
                        <div className="col-md-12 mt-3">
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="card-title"> Add Our Recent Web project
                                        <Link to={'/our-web-dev-project'} className="btn btn-primary btn-sm float-end"> Back </Link>
                                    </h6>
                                </div>
                                <div className="card-body">
                                    <form id="EarCanalForm" onSubmit={submitOurRecentWeb} >
                                        <div className="card-body">

                                            <div className="col-md-12">


                                                <div className="form-group">
                                                    <label htmlFor="history_name" className="col-form-label-sm">Our Recent Web Project Name </label>
                                                    <input id='history_name' type="text" value={ourRecentWeb.heading_name} className="form-control" name="heading_name" onChange={handleInput} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.heading_name}</span> */}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="web_link" className="col-form-label-sm">Web Link </label>
                                                    <input id='web_link' type="text" value={ourRecentWeb.web_link} className="form-control" name="web_link" onChange={handleInput} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.web_link}</span> */}
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="history_name" className="col-form-label-sm"> Image </label>
                                                    <input type="file" value={ourRecentWeb.image} className="form-control" name="image" onChange={onChangePicture} />
                                                    {/* <span className="text-danger">{ourRecentWeb.error_list.image}</span> */}

                                                </div>

                                                {/* <div className="form-group" style={{width:'100px',height:'90px'}}>
                                                    <i className='fa fa-close text-danger float-right'></i>
                                                    <img className="playerProfilePic_home_tile" src={picture} style={{width:'100px',height:'90px'}}></img>
                                                </div> */}
                                                {
                                                    picture !== '' && <div className="form-group" style={{ width: '100px', height: '90px' }}>
                                                        <img className="playerProfilePic_home_tile" src={picture} style={{ width: '100px', height: '90px' }} />
                                                    </div>

                                                }

                                                {
                                                    image.size > 524288 && <div className='text-danger mt-4'>Image Size Must be less than 0.5 Mb </div>
                                                }


                                                <div className="float-right">
                                                    <button type="submit" className="btn btn-sm btn-primary text-uppercase float-end mt-2"><i
                                                        className="fas fa-save"></i> Save
                                                    </button>
                                                </div>



                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </MasterDashboardLayout>
        </>
    )
}

export default AddOurRecentWebProjects
